import React, { useState, useEffect } from "react";
import { imgURL } from "../components/Config";
import "./pages.css";
import { getAllDataWithFlag } from "../services/CommonService";
import ReactPlayer from "react-player";
import Swal from "sweetalert2";

const GalleryPage = ({ projectId }) => {
  const [galleryItems, setGalleryItems] = useState([]);
  const [featuredItems, setFeaturedItems] = useState([]);
  const [regularItems, setRegularItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    const clampElements = document.querySelectorAll(".clamp-text");
    clampElements.forEach(el => {
      el.style.display = "-webkit-box";
      el.style.webkitLineClamp = "2";
      el.style.webkitBoxOrient = "vertical";
      el.style.overflow = "hidden";
    });
  }, []);


  useEffect(() => {
    // Fetch gallery items on component mount
    const fetchGalleryItems = async () => {
      try {
        const response = await getAllDataWithFlag(10);
        let galleryData = response.data?.gallery;
        if (projectId) galleryData = galleryData.filter((m) => (m.project_id == projectId));
        setGalleryItems(galleryData);
        setFeaturedItems(galleryData);

        setRegularItems(galleryData);
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err?.response?.data?.message || err?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    fetchGalleryItems();
  }, []);

  const openModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  if (!galleryItems) {
    return <div>Loading...</div>;
  }

  const banners = JSON.parse(localStorage.getItem('banners'));
  const bannerItem = banners?.length ? banners.find((r) => r.banner_type == 6) : featuredItems[0];
  if (!galleryItems?.length) return null;

  return (
    <div className="bg-light gallerypage">
      {/* Banner Section */}
      {!projectId && bannerItem && (
        <div className="position-relative" style={{ height: "500px" }}>
          <img
            src={(imgURL + bannerItem.image_path) || '/assets/images/bannerDefault.jpg'}
            alt={bannerItem.banner_title}
            className="w-100 h-100"
            style={{ objectFit: "cover" }}
          />
          <div className="position-absolute bottom-0 start-0 end-0 bg-dark bg-opacity-75 text-white p-4">
            <h1 className="display-5 fw-bold">{bannerItem.banner_title}</h1>
            <p className="lead">{bannerItem.description}</p>
          </div>
        </div>
      )}
      {/* Gallery Grid */}
      <div className="container py-5">
        {projectId && <h2 className="fw-bold mb-4">Gallery</h2>}
        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 ">
          {galleryItems.map((item) => (
            <div key={item.id} className="col-md-4">
              <div
                className="card card-image-container shadow-sm"
                style={{ cursor: "pointer" }}
                onClick={() => openModal(item)}
              >
                <div className="card-body position-relative w-100 h-100">
                  {item.type == 2 ? (
                    <img
                      src={imgURL + item.thumbnail}
                      alt={item.title}
                      className="media-img"
                    />
                  ) : (
                    <img
                      src={imgURL + item.thumbnail}
                      alt={item.title}
                      className="media-img"
                    />
                  )}

                  {item.type == 2 && (
                    <div className="play-icon-overlay d-flex justify-content-center align-items-center">
                      <i className="bi bi-play-fill fs-1 text-white"></i>
                    </div>
                  )}
                </div>
                <div className="card-footer">
                  <h5><b>Title:</b> {item.title} ({item.year})</h5>
                  <h6><b>Description: </b><span className="clamp-text">{item.description}</span></h6>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Modal for viewing images/videos */}
      {modalOpen && selectedItem && (
        <>
          <div className="modal show d-block custom-modal" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content bg-transparent position-relative overflow-hidden">

                <div className="modal-header galleryMHeader custom-header">
                  <h5 className="modal-title text-white">{selectedItem.title}</h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={closeModal}
                    aria-label="Close"
                  ></button>
                </div>

                <div className="modal-body p-0 custom-body">
                  <div className="text-center bg-black">
                    {selectedItem.type == 1 ? (
                      selectedItem.link == 2 ? (
                        <img
                          src={selectedItem.media_path}
                          alt={selectedItem.title}
                          className=" modal-img"
                        />
                      ) : (
                        <img
                          src={imgURL + selectedItem.media_path}
                          alt={selectedItem.title}
                          className=" modal-img"
                        />
                      )
                    ) : (
                      <div className="video-wrapper">
                        <ReactPlayer
                          url={selectedItem.media_path}
                          controls
                          width="100%"
                          height="100%"
                          config={{
                            file: {
                              attributes: {
                                style: { objectFit: 'cover' }
                              }
                            }
                          }}
                        /></div>
                    )}
                  </div>
                </div>

                <div className="modal-footer galleryMFooter custom-footer">
                  <div className="w-100 text-white description-overlay">
                    <h5>{selectedItem.title} ({selectedItem.year})</h5>
                    <p>{selectedItem.description}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop show"></div>
        </>
      )}
    </div>
  );
};

export default GalleryPage;
